import { ColumnBoxFlexFullWidth } from "./boxes";
import { styled } from '@mui/material';

export const ShadowContainer = styled(ColumnBoxFlexFullWidth)(({ theme }) => ({
  boxShadow: theme.shadows[2],
  borderRadius: 8,
  padding: theme.spacing(2),
  alignItems: 'center',
  [theme.breakpoints.up('tablet')]: {
    padding: theme.spacing(4),
    alignItems: 'flex-start',
  },
}));